export default "__VITE_ASSET__CdS0Qzi___"